// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__gRnWG","emails":"CreateEditClinics_emails__zxDc9","emailTagLabel":"CreateEditClinics_emailTagLabel__dHm4S"};